// @flow
import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";

import ContactForm from "./ContactForm";
import Details from "./Details";
import AdditionalDetails from "./AdditionalDetails";

import type { $AdditionalDetailsLayout, $AdditionalFields } from "flow/types";

type $Props = {
  classes: Object,
  className: string,
  additionalDetailsLayout: $AdditionalDetailsLayout,
  additionalFields: $AdditionalFields,
  aiSummary: string | null,
  isAiEnabled: boolean,
};

const Main = ({
  classes,
  className,
  additionalDetailsLayout,
  additionalFields,
  aiSummary,
  isAiEnabled,
}: $Props) => (
  <div className={classNames(classes.root, className)}>
    <div className={classes.paper}>
      <div className={classes.main}>
        <div className={classes.details}>
          <Details
            isListingDetail
            aiSummary={aiSummary}
            isAiEnabled={isAiEnabled}
          />
          <AdditionalDetails
            additionalDetailsLayout={additionalDetailsLayout}
            additionalFields={additionalFields}
          />
        </div>
        <div id="target" className={classes.formContainer}>
          <Typography className={classes.formheading}>Get in touch</Typography>
          <ContactForm />
        </div>
      </div>
    </div>
  </div>
);

export default withStyles((theme) => ({
  root: {
    [theme.breakpoints(900)]: {
      position: "relative",
      ...theme.globalPadding,
    },
  },

  paper: {
    width: "100%",
    maxWidth: "1184px",
    background: "#fff",
    boxShadow:
      "0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)", // material-design 1dp
    margin: "0px auto 96px auto",

    [theme.breakpoints(900)]: {
      borderRadius: theme.globalBorderRadius,
      margin: "-48px auto 96px auto",
    },
  },
  main: {
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints(600)]: {
      flexDirection: "row",
    },
  },
  details: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "16px 10px",

    [theme.breakpoints(900)]: {
      padding: theme.spacing.unit,
    },
  },
  formContainer: {
    width: "100%",
    backgroundColor: theme.colors.gray["050"],
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px",
    borderBottomLeftRadius: "4px",
    padding: "24px 16px",

    [theme.breakpoints(600)]: {
      maxWidth: "360px",
      borderBottomLeftRadius: "0px",
    },
  },
  formheading: {
    fontSize: "21px",
    fontWeight: "600",
    color: theme.colors.gray["600"],
    paddingBottom: theme.spacing.unit,
  },
}))(Main);
